import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const RoleProtectedRoute = ({ allowedRoles }) => {
    const role = localStorage.getItem('role');
    const baseRole = localStorage.getItem('base_role');

    if ((!role || !allowedRoles.includes(role)) && (!baseRole || !allowedRoles.includes(baseRole))) {
        const effectiveRole = baseRole || role;
        switch (effectiveRole) {
            case 'admin':
            case 'system_admin':
            case 'support':
                return <Navigate to="/admin-dashboard" replace />;
            case 'student':
                return <Navigate to="/student-dashboard" replace />;
            case 'university':
            case 'custom_role':
                return <Navigate to="/uni-dashboard" replace />;
            case 'pop':
                return <Navigate to="/pop-dashboard" replace />;
            case 'faculty':
                return <Navigate to="/faculty-dashboard" replace />;
            case 'tpo':
                return <Navigate to="/tpo-dashboard" replace />;
            default:
                return <Navigate to="/" replace />;
        }
    }

    return <Outlet />;
};

export default RoleProtectedRoute;
